// extracted by mini-css-extract-plugin
module.exports = {"ViewAgent":"table_ViewAgent__2z-9k","Table":"table_Table__1T0A-"};